import { lazy, useEffect, useState } from 'react';

import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { setL2Visible } from 'Deer/slice/DeerNav.slice';
import { useAuthenticatedUser } from 'components/hooks/dataHooks';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useProfilePage } from 'screens/Profile/hooks/dataHooks';
import { getRelationToLoggedInEmployeeApi } from 'screens/oneOnOneRabbit/InstancePage/apis';
import { retry } from 'utils/retry';

import { ProfileOverview } from './ProfileOverview';

const ProfilePage = lazy(() => retry(() => import('screens/Profile')));

const Profile = () => {
  const { employeeId } = useParams<{ employeeId: string }>();

  const { data: employee, isLoading } = useProfilePage({ employeeId });
  const { user } = useAuthenticatedUser();

  const dispatch = useDispatch();
  const { l1Module, teamType } = useRouteToNavLevels();
  const isTeamsProfilePage = l1Module === 'team' && ['directReports', 'allReports'].includes(teamType);

  const [relation, setRelation] = useState(null);
  const isVisitingOwnProfile = employeeId === user?.id;

  useEffect(() => {
    // leave the sidebar open for teams profile pages
    if (isTeamsProfilePage) {
      return;
    }
    dispatch(
      setL2Visible({
        isL2Visible: false,
      })
    );
  }, [dispatch, isTeamsProfilePage]);

  useEffect(() => {
    if (employeeId) {
      getRelationToLoggedInEmployeeApi({ employeeId }).then((res) => {
        setRelation(res?.entity);
      });
    } else {
      setRelation(null);
    }
  }, [employeeId]);

  if (isLoading) {
    return null;
  }

  return ['REPORTEE', 'SKIP_REPORTEE'].includes(relation) || isVisitingOwnProfile ? (
    <ProfileOverview employee={employee} isVisitingOwnProfile={isVisitingOwnProfile} />
  ) : (
    <ProfilePage />
  );
};

export { Profile };
